module["exports"] = [
  "Україна"
];
